"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyContextProvider = exports.useCurrency = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var CurrencyContext = /*#__PURE__*/_react["default"].createContext();
var CurrencyContextProvider = function CurrencyContextProvider(_ref) {
  var children = _ref.children,
    currencyData = _ref.currencyData;
  var _useState = (0, _react.useState)(currencyData),
    currency = _useState[0],
    setCurrency = _useState[1];
  return __jsx(CurrencyContext.Provider, {
    value: {
      currency: currency
    }
  }, children);
};
exports.CurrencyContextProvider = CurrencyContextProvider;
var useCurrency = function useCurrency() {
  return (0, _react.useContext)(CurrencyContext);
};
exports.useCurrency = useCurrency;